import{AspectRatio as t}from"radix-ui";const i=t.Root;export{i as AspectRatio};
//# sourceMappingURL=aspect-ratio.js.map
